import { i18n } from 'next-i18next';
import dayjs from 'dayjs';

require('dayjs/locale/el');

i18n?.init();
export const changeDateFormat = (value: Date) => {
  return i18n?.language === 'el'
    ? dayjs(new Date(value)).locale('el').format('DD MMM YYYY')
    : dayjs(new Date(value)).locale('en').format('DD MMM YYYY');
};

export const tagFormat = (value: Date) => {
  return i18n?.language === 'el'
    ? dayjs(new Date(value)).locale('el').format('DD.MM.YY')
    : dayjs(new Date(value)).locale('en').format('DD.MM.YY');
};

export default changeDateFormat;
